import StatsRule from "../../../../common/stats-rule";
import FootballState from "../../../state/football-state";
import FootballStatsCategory from "../../../stats/football-stats-category";

const FUMBLE_RECOVERY_STATES = [
    FootballState.FumbleRecovered,
    FootballState.FumbleNotRecovered,
    FootballState.FumbledSnapRecovered,
    FootballState.FumbledSnapLost
];

export default class FumbleRecoveryTouchdownStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            FUMBLE_RECOVERY_STATES.some((s) => play.historyContains(s)) &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const fumbleFragment = play.getPreceedingFragment(
            fragment,
            FUMBLE_RECOVERY_STATES
        );

        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: fumbleFragment.recoveredBy.teamId,
            playerId: fumbleFragment.recoveredBy.id,
            driveId: gameContext.currentDriveId,
            fragmentId: fumbleFragment.id,
            category: FootballStatsCategory.FUMBLE_RECOVERED,
            values: {
                touchdowns: 1
            }
        });
    }
}
